import { createSlice } from "@reduxjs/toolkit";
import { updateGroupProductFeatureAPI } from "../../services/updateGroupProductFeature";

const data = {
  isLoading: false,
  error: "",
  message: "",
  data: null,
  statusCode: undefined,
};

const updateGroupProductFeatureSlice = createSlice({
  name: "updateGroupProductFeatureMain",
  initialState: data,
  reducers: {
    updateGroupProductFeatureInfo(state) {
      state.isLoading = true;
    },
    updateGroupProductFeatureInfoSuccess(state, action) {
      state.isLoading = false;
      state.data = action.payload;
      state.message = "";
    },
    updateGroupProductFeatureInfoFailure(state, action) {
      const payload =
        action.payload && typeof action.payload === "object"
          ? action.payload
          : { message: action.payload };
      state.isLoading = false;
      state.message = payload.message ?? "";
      state.statusCode = payload.statusCode;
      state.data = null;
    },
    updateGroupProductFeatureInfoReset(state) {
      state.isLoading = false;
      state.message = "";
      state.data = null;
      state.error = "";
      state.statusCode = undefined;
    },
  },
});

export const updateGroupProductFeaturesHandler =
  (data, options = {}) =>
  async (dispatch) => {
  const requestOptions = { skipForbiddenRedirect: true, ...options };

  try {
    dispatch(updateGroupProductFeatureAction.updateGroupProductFeatureInfo());
    const response = await updateGroupProductFeatureAPI(data, requestOptions);
    dispatch(
      updateGroupProductFeatureAction.updateGroupProductFeatureInfoSuccess(
        response
      )
    );
  } catch (e) {
    const failurePayload =
      e && typeof e === "object" && "message" in e
        ? e
        : { message: e || "Something went wrong." };
    dispatch(
      updateGroupProductFeatureAction.updateGroupProductFeatureInfoFailure(
        failurePayload
      )
    );
  }
};
export default updateGroupProductFeatureSlice.reducer;
export const updateGroupProductFeatureAction =
  updateGroupProductFeatureSlice.actions;
